import { Product } from "../../interfaces/products/product";

export type AmazonClickPlacement =
  | "product-browser"
  | "product-collection"
  | "product-details";

interface AnalyticsWindow extends Window {
  gtag?: (...args: unknown[]) => void;
  dataLayer?: Array<Record<string, unknown>>;
}

/**
 * Track an outbound Amazon affiliate click without sending price information.
 * Works before GA4 is installed by queueing a GA4-compatible dataLayer event.
 */
export const trackAmazonClick = (
  product: Product,
  placement: AmazonClickPlacement,
) => {
  const analyticsWindow = window as AnalyticsWindow;

  const eventParams = {
    product_id: product._id,
    product_slug: product.slug,
    product_title: product.title,
    product_category: product.category,
    product_asin: product.asin || undefined,
    placement,
  };

  if (typeof analyticsWindow.gtag === "function") {
    analyticsWindow.gtag("event", "amazon_affiliate_click", eventParams);
    return;
  }

  if (Array.isArray(analyticsWindow.dataLayer)) {
    analyticsWindow.dataLayer.push({
      event: "amazon_affiliate_click",
      ...eventParams,
    });
  }
};
